/**
 * Language configuration for VizPI sessions.
 * Single source of truth — all files import from here.
 * 
 * CHI Study Counterbalancing:
 *   Condition A (even user IDs): 663 → 664
 *     663: findMinMax (with AI)
 *     664: inOrderTraversal (without AI)
 * 
 *   Condition B (odd user IDs): 666 → 665
 *     666: inOrderTraversal (with AI)
 *     665: findMinMax (without AI)
 */

const C_SESSIONS = [662]
const JAVA_SESSIONS = [663, 664, 665, 666, 669, 674, 675, 676, 677, 678]
const NO_AI_SESSIONS = [664, 665]
const SECOND_TASK_SESSIONS = [664, 665]

export const JUDGE0_LANGUAGE_IDS = {
  c: 50,      // GCC 9.2.0
  java: 62,   // OpenJDK 13.0.1
}

/**
 * Get the programming language for a given session ID.
 * Returns 'python' by default.
 */
export function getSessionLanguage(sessionId) {
  if (C_SESSIONS.includes(sessionId)) return 'c'
  if (JAVA_SESSIONS.includes(sessionId)) return 'java'
  return 'python'
}

/**
 * Check if a session uses a compiled language (Judge0) vs interpreted (Pyodide).
 */
export function isCompiledSession(sessionId) {
  const lang = getSessionLanguage(sessionId)
  return lang === 'c' || lang === 'java'
}

/**
 * Check if AI chat is enabled for a given session.
 */
export function isAIEnabled(sessionId) {
  return !NO_AI_SESSIONS.includes(sessionId)
}

/**
 * Check if this is the second task in a paired session.
 * Second tasks skip consent, demographics, and pre-task survey.
 */
export function isSecondTask(sessionId) {
  return SECOND_TASK_SESSIONS.includes(sessionId)
}

/**
 * Get the next session ID to redirect to after completing the first task.
 * Returns null if there's no next session.
 */
export function getNextSessionId(sessionId) {
  const TASK_PAIRS = {
    663: 664,  // Condition A: findMinMax (AI) → inOrderTraversal (no AI)
    666: 665,  // Condition B: inOrderTraversal (AI) → findMinMax (no AI)
  }
  return TASK_PAIRS[sessionId] || null
}